<template>
  <v-footer padless app>
    <v-col class="text-center pa-0" cols="12" style="font-size: 10px"
      >Copyright &copy; {{ new Date().getFullYear() }} inventory.jovani.com All Rights Reserved.</v-col
    >
  </v-footer>
</template>

<script>
export default {
  name: 'LayoutImportsFooter'
}
</script>
